import type { GameModeId } from '../types';
import type { GameMode, GameModeDefinition } from './GameMode';

/**
 * Modes are resolved by id, the same way rulesets are. Adding "co-op" or
 * "daily challenge" later means registering a definition here; the room, the
 * router and the leaderboard queries all keep working off the id string.
 */

const definitions = new Map<GameModeId, GameModeDefinition>();

export function registerGameMode(definition: GameModeDefinition): void {
  if (definitions.has(definition.id)) {
    throw new Error(`GameMode "${definition.id}" is already registered.`);
  }
  definitions.set(definition.id, definition);
}

export function hasGameMode(id: GameModeId): boolean {
  return definitions.has(id);
}

export function getGameModeDefinition(id: GameModeId): GameModeDefinition {
  const found = definitions.get(id);
  if (!found) {
    throw new Error(
      `Unknown GameMode "${id}". Registered: ${[...definitions.keys()].join(', ') || '(none)'}`,
    );
  }
  return found;
}

export function createGameMode(id: GameModeId, ruleSetId?: string): GameMode {
  return getGameModeDefinition(id).create(ruleSetId);
}

export function listGameModes(): GameModeDefinition[] {
  return [...definitions.values()];
}

/** Test-only. */
export function clearGameModeRegistry(): void {
  definitions.clear();
}
